export function parseModelLabels(labels?: string | null) {
  if (!labels) {
    return [];
  }

  return labels
    .split(/\r?\n/)
    .map((label) => label.trim())
    .filter(Boolean);
}
